import { createFileRoute } from '@tanstack/react-router'

import type { PerfilId } from '@/lib/visoes'

import { PaginaVisaoGeral } from '@/features/visao-geral/pagina'

export const Route = createFileRoute('/$perfil/visao-geral')({
  component: Tela,
})

function Tela() {
  const { perfil } = Route.useParams()
  return <PaginaVisaoGeral perfil={perfil as PerfilId} />
}
